/* eslint-disable max-len */
// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import api from '../../../services/api';

const howItWorksService = async () => {
  return api('/api/v2/pages/?type=how_it_works.HowItWorksPage&fields=description_paragraph1,description_paragraph2,gallery_image_picker(title,description)', {}, 'GET');
};


export {
  howItWorksService,
};
